import request from '@/utils/request';

/**获取验证码 */
export const staffList = (formData?: any) => {
  return request.get(
    '/api/Staff/List',
    {
      ...formData
    });
};

export const allStaff = (formData?: any) => {
  return request.get(
    '/api/Staff/All',
    {
      ...formData
    });
};
// 所有角色
export const allRole = () => {
  return request.get( '/api/Setting/Role/all',)
};